import { z } from 'zod'

export const assessmentsQueueFiltersSchema = z.object({
  companyId: z.number().int().positive().nullable(),
  positionId: z.number().int().positive().nullable(),
  shiftId: z.number().int().positive().nullable(),
})

export type AssessmentsQueueFiltersSchema = z.infer<
  typeof assessmentsQueueFiltersSchema
>
